import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { deviceListsMsg, deviceSelectionMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n/index.js';
import { deviceSelectionTabPath } from '../../../../../common/utils/deviceListTabsUtilsCoCo.js';
import { BreadCrumbs } from '../../../../../components/BreadCrumbs/index.js';
import { DetailsWrapper } from '../../../../../components/DetailsWrapper/index.js';
import { DeviceSelectionDetailsCoCo } from '../../../../../components/DeviceSelectionDetailsCoCo/DeviceSelectionDetailsCoCo.js';
import type { DeviceSelectionDetailsLoaderDataCoCo } from '../../../../../common/loaders.js';

export const CompanyInfoDeviceSelectionDetailsPageCoCo = () => {
  const { deviceSelection, deviceVariantGroups } = useLoaderData() as DeviceSelectionDetailsLoaderDataCoCo;

  return (
    <DetailsWrapper
      classes={['of-device-selection-details-coco']}
      detailsTop={
        <BreadCrumbs
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.COBB(deviceListsMsg), path: paths.COMPANY_INFO_CATALOGS },
            { name: t.AHB4(deviceSelectionMsg), path: deviceSelectionTabPath },
            { name: deviceSelection.name },
          ]}
        />
      }
      id={`device-selection-${deviceSelection.uuid}`}
      headingTop={t.AHB4(deviceSelectionMsg)}
      heading={deviceSelection.name}
      heroPicto="catalog"
    >
      <DeviceSelectionDetailsCoCo deviceSelection={deviceSelection} deviceVariantGroups={deviceVariantGroups} />
    </DetailsWrapper>
  );
};
